(function () {
  const GAP_REM = 4;         // space between repeated copies
  const SPEED_PX_S = 50;     // scroll speed (all blocks same)
  const SELECTORS =
    '.announcement-bar__message, .announcement-bar__text, .announcement__message, .announcement__text, [data-announcement]';

  const onReady = (fn) => (document.readyState === 'loading')
    ? document.addEventListener('DOMContentLoaded', fn, { once: true })
    : fn();

  onReady(() => {
    initAll(true);
    // Re-init if theme re-renders or on resize
    const mo = new MutationObserver(() => initAll());
    mo.observe(document.body, { childList: true, subtree: true });
    let raf;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => initAll(true));
    });
  });

  function initAll(force = false) {
    document.querySelectorAll('.announcement-bar').forEach((bar) => {
      bar.querySelectorAll(SELECTORS).forEach((wrap) => initOne(bar, wrap, force));
      bar.classList.add('has-marquee');
    });
  }

  function initOne(bar, wrap, force) {
    if (!force && wrap.dataset.marqueeInit === '1') return;

    const first = wrap.firstElementChild || wrap;
    if (!first || !first.textContent.trim()) return;

    // Build container
    const container = document.createElement('span');
    container.className = 'marquee__content';
    container.style.cssText = 'display:inline-flex;align-items:center;white-space:nowrap;will-change:transform';

    const base = first.cloneNode(true);
    wrap.innerHTML = '';
    wrap.appendChild(container);

    // Duplicate content until >= 2× bar width for seamless wrap
    const target = Math.max(bar.clientWidth * 2, 600);
    while (container.scrollWidth < target) {
      const copy = base.cloneNode(true);
      copy.style.marginRight = `${GAP_REM}rem`; // same gap between repeats
      container.appendChild(copy);
    }

    startTicker(bar, container, SPEED_PX_S);
    wrap.dataset.marqueeInit = '1';
  }

  function startTicker(bar, el, speed) {
    let x = 0, last = performance.now(), paused = false;

    const step = (now) => {
      const dt = (now - last) / 1000; last = now;
      if (!paused) {
        x -= speed * dt;
        const half = el.scrollWidth / 2; // we filled >= 2× width
        if (Math.abs(x) >= half) x += half;
        el.style.transform = `translateX(${x}px)`;
      }
      requestAnimationFrame(step);
    };
    requestAnimationFrame(step);

    bar.addEventListener('mouseenter', () => (paused = true), { passive: true });
    bar.addEventListener('mouseleave', () => (paused = false), { passive: true });
  }
})();
